import React from "react";
import ReactMarkdown from "react-markdown";

const StudioCreationMobile = ({ textes }) => {
  return (
    <div className="studio-creation-mobile mt-14" >
      <div className="container mx-auto min-h-screen flex flex-col items-center max-w-[1440px] p-4">
        <div className="w-[70%] mb-4 ">
          <ReactMarkdown
            className="text-6xl sm:text-4xl md:text-5xl leading-none mb-4 text-white"
            escapeHtml={false}
            components={{
              strong: ({ node, ...props }) => (
                <span className="text-[#00ffcc] font-sam font-[200]" {...props} />
              ),
              em: ({ node, ...props }) => (
                <span className="text-[#00ffcc] font-sam font-[200] [text-stroke:1px_#00FFCC] text-transparent" {...props} />
              ),
            }}
          >
            {textes?.studioCreationTitle}
          </ReactMarkdown>
        </div>

        <div className="w-[70%] items-center my-5">
          <ReactMarkdown
            className="text-xl sm:text-xl md:text-xl leading-relaxed text-white"
            escapeHtml={false}
            style={{ fontFamily: "Lexend" }}
            components={{
              strong: ({ node, ...props }) => (
                <span
                  className="text-strong text-xl sm:text-xl md:text-xl"
                  {...props}
                />
              ),
            }}
          >
            {textes?.studioCreationLongDescription}
          </ReactMarkdown>
        </div>

        <div className="relative h-[5vh]" />
        <div className="h-screen">
          <div className="flex justify-center items-center h-full w-full">
            <div className="text-center w-[300px] text-white ">
              <ReactMarkdown
                className="text-5xl sm:text-5xl md:text-5xl leading-24 text-white"
                escapeHtml={false}
                style={{ fontFamily: "Lexend" }}
                components={{
                  strong: ({ node, ...props }) => (
                    <>
                    <br/>
                    <span
                      className="text-strong text-5xl sm:text-6xl md:text-lg font-sam"
                      {...props}
                    />
                    <br/>
                    <br/>
                    </>
                  ),
                }}
              >
                {textes?.intro2}
              </ReactMarkdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudioCreationMobile;
